import React, { useEffect, useState } from "react";
import NewFormTextInput from "../../../../../components/FormTextInput/NewFormTextInput";
import AutoCompleteField from "../../../../../components/AutoCompleteField/AutoCompleteField";
import styles from "./Edufin.module.css";
import { Grid, InputLabel, TextField } from "@mui/material";
import CountryCodePhoneInput from "../../../../../components/CountryCodePhoneInput/CountryCodePhoneInput";
import SaveBtn from "../../../../../components/Buttons/SaveBtn";
import { ErrorType } from "../../../../../components/FormTextInput/types";
import { useSelector } from "react-redux";
import moment from "moment";
import { getYears } from "../../../../../components/CommonFunctions/CommonFunctions";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useAuthUser } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import MultiBranchSelectField from "../../../../../components/AutoCompleteField/MultiBranchSelectField";
import { getEdufinData } from "../../service/IntegrationsSlice";
import { useDispatch } from "react-redux";

const InstituteDetailsForEdufin = ({
  setShowIndex,
  SaveEdufinData,
  saveEdufinSuccess,
  saveEdufinData,
  instituteInfo,
  setInstituteInfo,
  contactInfo,
  setContactInfo,
  bankInfo,
  setBankInfo,
}: any) => {
  const instituteType = [
    { id: 0, value: "School" },
    { id: 1, value: "Colleges" },
    { id: 2, value: "Universities" },
    { id: 3, value: "Institutes" },
  ];

  const board = [
    { id: 0, value: "CBSE" },
    { id: 1, value: "ICSE" },
    { id: 2, value: "State Boards" },
    { id: 3, value: "IGCSE" },
    { id: 3, value: "NIOS" },
  ];

  const bank = [
    { id: 0, value: "Savings Account" },
    { id: 1, value: "Current Account" },
    { id: 2, value: "Salary Account" },
  ];

  const auth = useAuthUser();
  const authUser = auth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const instituteDetails = authUser?.institute?.[0]?.instituteDetails;

  const yearOptions = getYears(moment().year() - 20, moment().year())
    .reverse()
    .map((year, index) => ({
      id: index,
      value: year.toString(), // keep it string like your board values
    }));

  const [showErrMsz, setShowErrMsz] = React.useState<boolean>(true);
  const [errorType, setErrorType] = React.useState<ErrorType>("client");
  const pinRegex = /^\d{6}$/;
  const [pinError, setPinError] = React.useState<boolean>(true);
  const [instituteName, setInstituteName] = React.useState<boolean>(true);
  const [validStateBranch, setValidStateBranch] = React.useState<boolean>(true);
  const [address, setAddress] = React.useState<boolean>(true);
  const [averageFees, setAverageFees] = React.useState<boolean>(true);
  const [studentStrength, setStudentStrength] = React.useState<boolean>(true);
  const [teacherStrength, setTeacherStrength] = React.useState<boolean>(true);
  const [affiliationCode, setAddiliationCode] = React.useState<boolean>(true);
  const [validStateInstituteType, setValidStateInstituteType] =
    React.useState<boolean>(true);
  const [validStateOfBoard, setValidStateOfBoard] =
    React.useState<boolean>(true);
  const [validStateOperationSince, setValidStateOperationSince] =
    React.useState<boolean>(true);

  const [principalName, setPrincipalName] = React.useState<boolean>(true);
  const [principalNumber, setPrincipalNumber] = React.useState<boolean>(true);
  const [spocPersonName, setSpocPersonName] = React.useState<boolean>(true);
  const [spocPersonNumber, setSpocPersonNumber] = React.useState<boolean>(true);
  const [spocPersonEmail, setSpocPersonEmail] = React.useState<boolean>(true);
  const [accountEmail, setAccountEmail] = React.useState<boolean>(true);
  const [contactCountryCode, setContactCountryCode] = React.useState("91");
  const [contactCountryCodeForSPOC, setContactCountryCodeForSPOC] =
    React.useState("91");

  const [bankName, setBankName] = React.useState<boolean>(true);
  const [bankAccountNumber, setBankAccountNumber] =
    React.useState<boolean>(true);
  const [ifscCode, setIfscCode] = React.useState<boolean>(true);
  const [accountType, setAccountType] = React.useState<boolean>(true);
  const [beneficiaryName, setBeneficiaryName] = React.useState<boolean>(true);
  const [website, setWebsite] = React.useState<boolean>(true);
  const { edufinData } = useSelector((state: any) => state.edufin);

  const handleChange = React.useCallback(
    (event: any) => {
      setShowErrMsz(true);
      setErrorType("client");
      if (event.target.id === "pin") {
        if (event.target.value.trimStart() !== "") {
          if (pinRegex.test(event.target.value)) {
            setPinError(true);
          } else {
            setPinError(false);
          }
        } else {
          setPinError(true);
        }
      }

      const { id, value } = event.target;

      const lowercaseValue =
        id === "instituteEmail"
          ? value.toLowerCase().trimStart()
          : id === "averageFees" ||
            id === "teacherStrength" ||
            id === "studentStrength" ||
            id === "affiliationCode"
          ? value?.replace(/[^0-9]/g, "")
          : id === "instituteName" || id === "city" || id === "state"
          ? value?.replace(/[^a-zA-Z\s]/g, "")
          : value.trimStart();

      setInstituteInfo({
        ...instituteInfo,
        [id]: lowercaseValue,
      });
    },
    [setInstituteInfo, pinRegex]
  );

  const setValidateInstituteName = React.useCallback((val: boolean) => {
    setInstituteName(val);
  }, []);

  const setValidateAddress = React.useCallback((val: boolean) => {
    setAddress(val);
  }, []);

  const setValidateFee = React.useCallback((val: boolean) => {
    setAverageFees(val);
  }, []);
  const setValidateStudentStrength = React.useCallback((val: boolean) => {
    setStudentStrength(val);
  }, []);
  const setValidateTeacherStrength = React.useCallback((val: boolean) => {
    setTeacherStrength(val);
  }, []);
  const setValidateAffCode = React.useCallback((val: boolean) => {
    setAddiliationCode(val);
  }, []);

  const setValidatePrincipalName = React.useCallback((val: boolean) => {
    setPrincipalName(val);
  }, []);
  const setValidatePrincipalNumber = React.useCallback((val: boolean) => {
    setPrincipalNumber(val);
  }, []);
  const setValidateSpocPersonName = React.useCallback((val: boolean) => {
    setSpocPersonName(val);
  }, []);
  const setValidateSpocPersonNumber = React.useCallback((val: boolean) => {
    setSpocPersonNumber(val);
  }, []);
  const setValidateSpocPersonEmail = React.useCallback((val: boolean) => {
    setSpocPersonEmail(val);
  }, []);
  const setValidateAccontEmail = React.useCallback((val: boolean) => {
    setAccountEmail(val);
  }, []);

  const setValidateBankName = React.useCallback((val: boolean) => {
    setBankName(val);
  }, []);
  const setValidateBankAccountNumber = React.useCallback((val: boolean) => {
    setBankAccountNumber(val);
  }, []);
  const setValidateIfscCode = React.useCallback((val: boolean) => {
    setIfscCode(val);
  }, []);
  const setValidateBeneficiaryName = React.useCallback((val: boolean) => {
    setBeneficiaryName(val);
  }, []);
  const setValidateWebsite = React.useCallback((val: boolean) => {
    setWebsite(val);
  }, []);
  const setValidateAccountType = React.useCallback((val: boolean) => {
    setAccountType(val);
  }, []);

  const handleChangeForContact = React.useCallback((event: any) => {
    setShowErrMsz(true);
    setErrorType("client");
    const { id, value } = event.target;
    const lowercaseValue =
      id === "instituteEmail"
        ? value.toLowerCase().trimStart()
        : id === "spocPersonName" || id === "principalName"
        ? value?.replace(/[^a-zA-Z\s]/g, "")
        : value.trimStart();

    setContactInfo((prev: any) => ({
      ...prev,
      [id]: lowercaseValue,
    }));
  }, []);

  const handleChangeForBank = React.useCallback((event: any) => {
    setShowErrMsz(true);
    setErrorType("client");
    const { id, value } = event.target;
    const lowercaseValue =
      id === "instituteEmail" || id === "website"
        ? value.toLowerCase().trimStart()
        : id === "bankAccountNumber"
        ? value?.replace(/[^0-9]/g, "")
        : id === "bankName" || id === "website" || id === "beneficiaryName"
        ? value?.replace(/[^a-zA-Z\s]/g, "")
        : value.trimStart();

    setBankInfo((prev: any) => ({
      ...prev,
      [id]: lowercaseValue,
    }));
  }, []);

  const branches = useSelector((state: any) => state.branch.branchList);

  // const onBranchChange = React.useCallback(
  //   (event: object, value: any | null) => {
  //     if (value !== null) {
  //       setInstituteInfo({
  //         ...instituteInfo,
  //         branchId: value.id,
  //         branchName: value.branchName,
  //       });
  //       setValidStateBranch(true);
  //     } else {
  //       setInstituteInfo({
  //         ...instituteInfo,
  //         branchId: "",
  //         branchName: "",
  //       });
  //       setValidStateBranch(false);
  //     }
  //   },
  //   [instituteInfo]
  // );

  const onBranchChange = React.useCallback(
    (event: object, value: any[] | null) => {
      if (value && value.length > 0) {
        const formattedBranches = value.map((v) => ({
          branchId: v.id,
          branchName: v.branchName,
        }));

        setInstituteInfo({
          ...instituteInfo,
          branches: formattedBranches,
        });
        setValidStateBranch(true);
      } else {
        setInstituteInfo({
          ...instituteInfo,
          branches: [],
        });
        setValidStateBranch(false);
      }
    },
    [instituteInfo]
  );

  const onInstituteTypeChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setInstituteInfo({
          ...instituteInfo,
          instituteType: value?.value,
        });
        setValidStateInstituteType(true);
      } else {
        setInstituteInfo({
          ...instituteInfo,
          instituteType: "",
        });
        setValidStateInstituteType(false);
      }
    },
    [instituteInfo]
  );

  const onBoardChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setInstituteInfo({
          ...instituteInfo,
          board: value?.value,
        });
        setValidStateOfBoard(true);
      } else {
        setInstituteInfo({
          ...instituteInfo,
          board: "",
        });
        setValidStateOfBoard(false);
      }
    },
    [instituteInfo]
  );

  const onOperationSinceChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setInstituteInfo({
          ...instituteInfo,
          operationSince: value?.value,
        });
        setValidStateOperationSince(true);
      } else {
        setInstituteInfo({
          ...instituteInfo,
          operationSince: "",
        });
        setValidStateOperationSince(false);
      }
    },
    [instituteInfo]
  );

  const onAccountTypeChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setBankInfo({
          ...bankInfo,
          accountType: value.value,
        });
        setValidateAccountType(true);
      } else {
        setBankInfo({
          ...bankInfo,
          accountType: "",
        });
        setValidateAccountType(false);
      }
    },
    [bankInfo]
  );

  // const defaultOption = branches
  //   ? branches?.find((branch: any) => branch.id === instituteInfo.branchId)
  //   : "";

  const defaultOption =
    branches && instituteInfo?.branches?.length > 0
      ? branches.filter((branch: any) =>
          instituteInfo.branches.some((b: any) => b.branchId === branch.id)
        )
      : [];

  const defaultOptionForInstituteType = instituteType
    ? instituteType?.find(
        (branch: any) => branch.value === instituteInfo.instituteType
      )
    : "";

  const defaultOptionForOperationSince = yearOptions
    ? yearOptions?.find(
        (branch: any) => branch.value === instituteInfo.operationSince
      )
    : "";

  const defaultOptionForBoard = board
    ? board?.find((branch: any) => branch.value === instituteInfo.board)
    : "";

  const defaultOptionForBank = bank
    ? bank?.find((branch: any) => branch.value === bankInfo.accountType)
    : "";

  const handlePinChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setShowErrMsz(true);
      setPinError(true);
      setErrorType("client");

      const { id, value } = event.target;

      const processedValue =
        id === "pincode"
          ? value.replace(/\D/g, "")
          : id === "email"
          ? value.toLowerCase().trimStart()
          : value.trimStart();

      setInstituteInfo((prevDetails: any) => ({
        ...prevDetails,
        [id]: processedValue,
      }));

      if (id === "pincode") {
        if (!pinRegex.test(processedValue)) {
          setPinError(false);
        } else {
          setPinError(true);
        }
        if (processedValue?.length >= 6) {
          fetchPincodeData(processedValue);
        }
      }
    },
    [pinRegex]
  );

  const fetchPincodeData = async (pin: string) => {
    try {
      const response = await axios.get(
        `https://api.postalpincode.in/pincode/${pin}`
      );
      if (response.data && response.data.length > 0) {
        const pinData = response.data[0];

        const firstPostOffice = pinData?.PostOffice?.[0];
        if (firstPostOffice !== null) {
          setInstituteInfo((prevDetails: any) => ({
            ...prevDetails,
            city: firstPostOffice?.District,
            state: firstPostOffice?.State,
          }));
        } else {
          setInstituteInfo((prevDetails: any) => ({
            ...prevDetails,
            city: "",
            state: "",
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching pincode data:", error);
    }
  };

  const handleSubmit = () => {
    // setShowIndex(1);
    const id = localStorage.getItem("idForEdufinForm");

    if (!instituteInfo.instituteName) {
      setInstituteName(false);
      return;
    }
    if (instituteInfo.branches <= 0) {
      setValidStateBranch(false);
      return;
    }
    if (!instituteInfo.address) {
      setAddress(false);
      return;
    }
    if (!instituteInfo.pincode) {
      setPinError(false);
      return;
    }
    if (!instituteInfo.operationSince) {
      setValidStateOperationSince(false);
      return;
    }
    if (!instituteInfo.averageFees) {
      setAverageFees(false);
      return;
    }
    if (!instituteInfo.studentStrength) {
      setStudentStrength(false);
      return;
    }
    if (!instituteInfo.teacherStrength) {
      setTeacherStrength(false);
      return;
    }
    // if (!instituteInfo.affiliationCode) {
    //   setAddiliationCode(false);
    //   return;
    // }

    if (!contactInfo.principalName) {
      setPrincipalName(false);
      return;
    }
    if (!contactInfo.principalNumber) {
      setPrincipalNumber(false);
      return;
    }
    if (!contactInfo.spocPersonName) {
      setSpocPersonName(false);
      return;
    }
    if (!contactInfo.spocPersonNumber) {
      setSpocPersonNumber(false);
      return;
    }
    if (!contactInfo.spocPersonEmail) {
      setSpocPersonEmail(false);
      return;
    }
    if (!contactInfo.accountEmail) {
      setAccountEmail(false);
      return;
    }
    if (!bankInfo.bankName) {
      setBankName(false);
      return;
    }
    if (!bankInfo.bankAccountNumber) {
      setBankAccountNumber(false);
      return;
    }
    if (!bankInfo.ifscCode) {
      setIfscCode(false);
      return;
    }
    if (!bankInfo.accountType) {
      setAccountType(false);
      return;
    }
    if (!bankInfo.beneficiaryName) {
      setBeneficiaryName(false);
      return;
    }

    const data = {
      loanApplicationData: {
        instituteDetail: {
          instituteName: instituteInfo?.instituteName,
          branches: instituteInfo?.branches,
          address: instituteInfo?.address,
          city: instituteInfo?.city,
          state: instituteInfo?.state,
          pincode: instituteInfo?.pincode,
          operationSince: instituteInfo?.operationSince,
          averageFees: instituteInfo?.averageFees,
          studentStrength: instituteInfo?.studentStrength,
          teacherStrength: instituteInfo?.teacherStrength,
          affiliationCode: instituteInfo?.affiliationCode,
          instituteType: instituteInfo?.instituteType,
          board: instituteInfo?.board,
        },

        contactDetail: {
          principalName: contactInfo?.principalName,
          principalNumber: contactInfo?.principalNumber,
          spocPersonName: contactInfo?.spocPersonName,
          spocPersonNumber: contactInfo?.spocPersonNumber,
          spocPersonEmail: contactInfo?.spocPersonEmail,
          accountEmail: contactInfo?.accountEmail,
          contactCountryCodeForSPOC: contactCountryCodeForSPOC,
          contactCountryCode: contactCountryCode,
        },
        bankDetail: {
          bankName: bankInfo?.bankName,
          bankAccountNumber: bankInfo?.bankAccountNumber,
          ifscCode: bankInfo?.ifscCode,
          accountType: bankInfo?.accountType,
          beneficiaryName: bankInfo?.beneficiaryName,
          website: bankInfo?.website,
        },
      },
      instituteId: instituteDetails?.id,
      branches: instituteInfo?.branches,
      isPartiallyFilled: true,
    };
    const finalPayload = id ? { ...data, id: id } : data;

    localStorage.setItem("instituteData", JSON.stringify(data));
    SaveEdufinData(finalPayload);
  };

  useEffect(() => {
    if (
      saveEdufinSuccess === true &&
      saveEdufinData?.isPartiallyFilled === true
    ) {
      setShowIndex(1);
    }
  }, [saveEdufinSuccess]);

  return (
    <>
      <div className={styles.instutueDetailsContainer}>
        <div className={styles.groupHeader}>Institute Details</div>
        <div className={styles.instutueDetailsBox}>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                onChange={handleChange}
                validate={true}
                label="Institute Name"
                type="text"
                id={"instituteName"}
                inputProps={{
                  maxLength: 100,
                }}
                require={true}
                error={!instituteName}
                setValidStatus={setValidateInstituteName}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={instituteInfo?.instituteName}
              />
            </div>
            <div style={{ width: "500px" }}>
              {/* <AutoCompleteField
                id="branchId"
                label="Branch"
                options={branches}
                optionLabel={"branchName"}
                required={true}
                onChange={onBranchChange}
                value={defaultOption}
                validState={validStateBranch}
                disableClearable={instituteInfo?.branchId === "" ? true : false}
              /> */}
              <MultiBranchSelectField
                id="branchId"
                label="Branch"
                options={branches?.filter(
                  (d: any) =>
                    d?.isEdufinLoanConfigured === false ||
                    d?.isEdufinLoanConfigured === undefined ||
                    d?.isEdufinLoanConfigured === null
                )}
                onChange={onBranchChange}
                value={defaultOption}
                disableClearable={
                  instituteInfo?.branches?.length > 0 ? true : false
                }
                required={true}
                validState={validStateBranch}
              />
            </div>
          </div>
          <div className={styles.groupingBox}>
            <div style={{ width: "100%" }}>
              <NewFormTextInput
                onChange={handleChange}
                validate={true}
                label="Address"
                type="text"
                id={"address"}
                inputProps={{
                  maxLength: 100,
                }}
                require={true}
                error={!address}
                setValidStatus={setValidateAddress}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={instituteInfo?.address}
              />
            </div>
          </div>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                onChange={handleChange}
                validate={true}
                label="City"
                type="text"
                id={"city"}
                inputProps={{
                  maxLength: 100,
                }}
                require={false}
                value={instituteInfo?.city}
              />
            </div>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                onChange={handleChange}
                validate={true}
                label="State"
                type="text"
                id={"state"}
                inputProps={{
                  maxLength: 100,
                }}
                require={false}
                value={instituteInfo?.state}
              />
            </div>
          </div>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <Grid item xs={6}>
                <InputLabel
                  sx={{
                    fontSize: "12px",
                    color: "#142C44",
                    fontWeight: "500",
                    marginBottom: "6px",
                  }}
                >
                  Pincode <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <TextField
                  style={{ width: "100%" }}
                  size="small"
                  id={"pincode"}
                  value={instituteInfo.pincode}
                  inputProps={{
                    maxLength: 6,
                  }}
                  // onChange={handleChange}
                  onChange={handlePinChange}
                  fullWidth
                  variant="outlined"
                  error={!pinError}
                  type="text"
                  helperText={!pinError ? "Invalid PIN code" : ""}
                  required={true}
                />
              </Grid>
            </div>
            <div style={{ width: "500px" }}>
              <AutoCompleteField
                id="operationSince"
                label="Operation Since"
                options={yearOptions}
                optionLabel={"value"}
                required={true}
                onChange={onOperationSinceChange}
                value={defaultOptionForOperationSince}
                validState={validStateOperationSince}
                disableClearable={
                  instituteInfo?.operationSince === "" ? true : false
                }
              />
            </div>
          </div>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                onChange={handleChange}
                validate={true}
                label="Average Fee"
                type="text"
                id={"averageFees"}
                inputProps={{
                  maxLength: 100,
                }}
                require={true}
                error={!averageFees}
                setValidStatus={setValidateFee}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={instituteInfo?.averageFees}
              />
            </div>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                onChange={handleChange}
                validate={true}
                label="Student Strength"
                type="text"
                id={"studentStrength"}
                inputProps={{
                  maxLength: 100,
                }}
                require={true}
                error={!studentStrength}
                setValidStatus={setValidateStudentStrength}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={instituteInfo?.studentStrength}
              />
            </div>
          </div>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                onChange={handleChange}
                validate={true}
                label="Teacher Strength"
                type="text"
                id={"teacherStrength"}
                inputProps={{
                  maxLength: 100,
                }}
                require={true}
                error={!teacherStrength}
                setValidStatus={setValidateTeacherStrength}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={instituteInfo?.teacherStrength}
              />
            </div>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                onChange={handleChange}
                validate={true}
                label="Affiliation Code"
                type="text"
                id={"affiliationCode"}
                inputProps={{
                  maxLength: 100,
                }}
                require={false}
                error={!affiliationCode}
                // setValidStatus={setValidateAffCode}
                // showErrorMessage={showErrMsz}
                // errorType={errorType}
                value={instituteInfo?.affiliationCode}
              />
            </div>
          </div>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <AutoCompleteField
                id="branchId"
                label="Institute Type"
                options={instituteType}
                optionLabel={"value"}
                required={true}
                onChange={onInstituteTypeChange}
                value={defaultOptionForInstituteType}
                validState={validStateInstituteType}
                disableClearable={
                  instituteInfo?.instituteType === "" ? true : false
                }
              />
            </div>
            <div style={{ width: "500px" }}>
              <AutoCompleteField
                id="board"
                label="Board"
                options={board}
                optionLabel={"value"}
                required={false}
                onChange={onBoardChange}
                value={defaultOptionForBoard}
                // validState={validStateOfBoard}
                validState={true}

                // disableClearable={instituteInfo?.board === "" ? true : false}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.instutueDetailsContainer}>
        <div className={styles.groupHeader}>Contact Information</div>
        <div className={styles.instutueDetailsBox}>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                validate={true}
                label="Principal Name"
                type="text"
                id={"principalName"}
                inputProps={{
                  maxLength: 100,
                }}
                onChange={handleChangeForContact}
                require={true}
                error={!principalName}
                setValidStatus={setValidatePrincipalName}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={contactInfo?.principalName}
              />
            </div>
            <div style={{ width: "500px" }}>
              <Grid item xs={6}>
                <InputLabel
                  sx={{
                    fontSize: "12px",
                    color: "#142C44",
                    fontWeight: "500",
                    marginBottom: "5px",
                    fontFamily: "Poppins",
                    display: "flex",
                  }}
                >
                  Phone Number
                  <p style={{ margin: "0px 4px", color: "#D32F2F" }}>*</p>
                </InputLabel>
                <CountryCodePhoneInput
                  value={contactInfo.principalNumber}
                  onChange={(event: any, country: any) => {
                    if (event !== "") {
                      setValidatePrincipalNumber(
                        isValidPhoneNumber(
                          event.replace(country.dialCode, ""),
                          country.countryCode.toUpperCase()
                        )
                      );
                    }

                    setContactCountryCode(country.dialCode);
                    setContactInfo({
                      ...contactInfo,
                      principalNumber: event,
                      contactCountryCode: country.dialCode,
                    });
                  }}
                  error={principalNumber}
                />
              </Grid>
            </div>
          </div>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                validate={true}
                label="SPOC Person Name"
                type="text"
                id={"spocPersonName"}
                inputProps={{
                  maxLength: 100,
                }}
                require={true}
                onChange={handleChangeForContact}
                error={!spocPersonName}
                setValidStatus={setValidateSpocPersonName}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={contactInfo?.spocPersonName}
              />
            </div>
            <div style={{ width: "500px" }}>
              {/* <NewFormTextInput
                validate={true}
                label="SPOC Person No"
                type="number"
                id={"spocPersonNumber"}
                inputProps={{
                  maxLength: 100,
                }}
                require={true}
                onChange={handleChangeForContact}
                error={!spocPersonNumber}
                setValidStatus={setValidateSpocPersonNumber}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={contactInfo?.spocPersonNumber}
              /> */}
              <Grid item xs={6}>
                <InputLabel
                  sx={{
                    fontSize: "12px",
                    color: "#142C44",
                    fontWeight: "500",
                    marginBottom: "5px",
                    fontFamily: "Poppins",
                    display: "flex",
                  }}
                >
                  SPOC Phone Number
                  <p style={{ margin: "0px 4px", color: "#D32F2F" }}>*</p>
                </InputLabel>
                <CountryCodePhoneInput
                  value={contactInfo?.spocPersonNumber}
                  onChange={(event: any, country: any) => {
                    if (event !== "") {
                      setValidateSpocPersonNumber(
                        isValidPhoneNumber(
                          event.replace(country.dialCode, ""),
                          country.countryCode.toUpperCase()
                        )
                      );
                    }

                    setContactCountryCodeForSPOC(country.dialCode);
                    setContactInfo({
                      ...contactInfo,
                      spocPersonNumber: event,
                      contactCountryCode: country.dialCode,
                    });
                  }}
                  error={spocPersonNumber}
                />
              </Grid>
            </div>
          </div>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                validate={true}
                label="SPOC Person Email ID"
                type="email"
                id={"spocPersonEmail"}
                inputProps={{
                  maxLength: 100,
                }}
                require={true}
                onChange={handleChangeForContact}
                error={!spocPersonEmail}
                setValidStatus={setValidateSpocPersonEmail}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={contactInfo?.spocPersonEmail}
              />
            </div>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                validate={true}
                label="Accounts Team Email ID"
                type="email"
                id={"accountEmail"}
                inputProps={{
                  maxLength: 100,
                }}
                require={true}
                onChange={handleChangeForContact}
                error={!accountEmail}
                setValidStatus={setValidateAccontEmail}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={contactInfo?.accountEmail}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.instutueDetailsContainer}>
        <div className={styles.groupHeader}>Banking Details</div>
        <div className={styles.instutueDetailsBox}>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                validate={true}
                label="Bank Name"
                type="text"
                id={"bankName"}
                inputProps={{
                  maxLength: 100,
                }}
                onChange={handleChangeForBank}
                require={true}
                error={!bankName}
                setValidStatus={setValidateBankName}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={bankInfo?.bankName}
              />
            </div>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                validate={true}
                label="Bank Account No"
                type="text"
                id={"bankAccountNumber"}
                inputProps={{
                  maxLength: 100,
                }}
                onChange={handleChangeForBank}
                require={true}
                error={!bankAccountNumber}
                setValidStatus={setValidateBankAccountNumber}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={bankInfo?.bankAccountNumber}
              />
            </div>
          </div>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                validate={true}
                label="Bank IFSC Code"
                type="text"
                id={"ifscCode"}
                inputProps={{
                  maxLength: 100,
                }}
                require={true}
                onChange={handleChangeForBank}
                error={!ifscCode}
                setValidStatus={setValidateIfscCode}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={bankInfo?.ifscCode}
              />
            </div>
            <div style={{ width: "500px" }}>
              <AutoCompleteField
                id="accountType"
                label="AccountType"
                options={bank}
                optionLabel={"value"}
                required={true}
                onChange={onAccountTypeChange}
                value={defaultOptionForBank}
                validState={accountType}
                disableClearable={bankInfo?.accountType === "" ? true : false}
              />
            </div>
          </div>
          <div className={styles.groupingBox}>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                validate={true}
                label="Benficiary Name"
                type="text"
                id={"beneficiaryName"}
                inputProps={{
                  maxLength: 100,
                }}
                require={true}
                onChange={handleChangeForBank}
                error={!beneficiaryName}
                setValidStatus={setValidateBeneficiaryName}
                showErrorMessage={showErrMsz}
                errorType={errorType}
                value={bankInfo?.beneficiaryName}
              />
            </div>
            <div style={{ width: "500px" }}>
              <NewFormTextInput
                validate={false}
                label="Webite/Social Media(optional)"
                type="text"
                id={"website"}
                inputProps={{
                  maxLength: 100,
                }}
                require={false}
                onChange={handleChangeForBank}
                error={false}
                setValidStatus={setValidateWebsite}
                value={bankInfo?.website}
                // showErrorMessage={showErrMsz}
                // errorType={errorType}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <SaveBtn
          buttonText={"Next"}
          onClick={() => {
            handleSubmit();
          }}
        />
      </div>
    </>
  );
};

export default InstituteDetailsForEdufin;
